/**
 * Convert video URL to embeddable format
 * Supports YouTube and Vimeo URLs
 */
export function getEmbedUrl(url: string): string {
    try {
        const urlObj = new URL(url);

        // Vimeo: https://vimeo.com/VIDEO_ID -> https://player.vimeo.com/video/VIDEO_ID
        // Also handles already-embed URLs: https://player.vimeo.com/video/VIDEO_ID
        if (urlObj.hostname.includes("vimeo.com")) {
            // Already an embed URL — return as-is (strip existing query params, they get re-added by VideoLoader)
            if (urlObj.hostname === "player.vimeo.com") {
                return `${urlObj.origin}${urlObj.pathname}`;
            }
            const videoId = urlObj.pathname.split("/").filter(Boolean)[0];
            return `https://player.vimeo.com/video/${videoId}`;
        }

        // YouTube: already in embed format or regular URL
        if (urlObj.hostname.includes("youtube.com") || urlObj.hostname.includes("youtu.be")) {
            // If already an embed URL, return as is
            if (urlObj.pathname.includes("/embed/")) {
                return url;
            }

            // Convert regular YouTube URL to embed
            const videoId = urlObj.searchParams.get("v") || urlObj.pathname.split("/").pop();
            return `https://www.youtube.com/embed/${videoId}`;
        }

        // Return original URL if not recognized
        return url;
    } catch {
        // If URL parsing fails, return original
        return url;
    }
}

/**
 * Check if URL is a YouTube or Vimeo link (requires embed iframe)
 */
export function isEmbedVideo(url: string | undefined): boolean {
    if (!url) return false;
    try {
        const urlObj = new URL(url);
        return urlObj.hostname.includes("youtube.com") || urlObj.hostname.includes("youtu.be") || urlObj.hostname.includes("vimeo.com");
    } catch {
        return false;
    }
}
